import React from 'react';
import BaseModal from '../baseModal';
import './style.scss';

const RequirementErrorModal = ({ show, close, errors }) => {
    return (
        <BaseModal show={show} handleClose={close} title={''}>
            <p id='bns-warning'>Requirement Error</p>
            <ul id='bnsul'>
                <li>{errors.nameCheck ? '✅' : '❌'} : BNS Name</li>
                <li>{errors.zonefileCheck ? '✅' : '❌'} : Zonefile</li>
                <li>{errors.storageCheck ? '✅' : '❌'} : Storage Discovery</li>
            </ul>
        </BaseModal>
    );
};

export default RequirementErrorModal;
